const mountPageDrawers = () => {
  document.querySelectorAll("[data-page-drawer]").forEach((container) => {
    if (container.dataset.drawerMounted === "true") return
    container.dataset.drawerMounted = "true"

    const openButtons = Array.from(container.querySelectorAll("[data-page-drawer-open]"))
    const panels = Array.from(container.querySelectorAll("[data-page-drawer-panel]"))
    const backdrop = container.querySelector("[data-page-drawer-backdrop]")
    const closeButtons = Array.from(container.querySelectorAll("[data-page-drawer-close]"))
    let activeOpenButton = openButtons[0] || null

    if (openButtons.length === 0 || panels.length === 0 || !backdrop) return

    const panelForButton = (button) => {
      const targetId = button?.getAttribute("aria-controls")
      if (!targetId) return panels[0]

      return panels.find((candidate) => candidate.id === targetId) || panels[0]
    }

    const hidePanels = () => {
      panels.forEach((panel) => {
        panel.hidden = true
        panel.setAttribute("aria-hidden", "true")
      })
    }

    const close = () => {
      hidePanels()
      backdrop.hidden = true
      openButtons.forEach((button) => button.setAttribute("aria-expanded", "false"))
      document.removeEventListener("keydown", handleKeydown)
    }

    const open = (triggerButton = activeOpenButton) => {
      activeOpenButton = triggerButton || openButtons[0] || null
      const activePanel = panelForButton(activeOpenButton)
      hidePanels()
      activePanel.hidden = false
      backdrop.hidden = false
      activePanel.setAttribute("aria-hidden", "false")
      openButtons.forEach((button) => button.setAttribute("aria-expanded", button === activeOpenButton ? "true" : "false"))
      document.addEventListener("keydown", handleKeydown)
    }

    const handleKeydown = (event) => {
      if (event.key === "Escape") close()
    }

    openButtons.forEach((button) => {
      button.addEventListener("click", () => open(button))
    })
    backdrop.addEventListener("click", close)
    closeButtons.forEach((button) => button.addEventListener("click", close))

    const hashPanel = panels.find((candidate) => candidate.id && window.location.hash === `#${candidate.id}`)
    if (hashPanel) {
      const hashButton = openButtons.find((button) => button.getAttribute("aria-controls") === hashPanel.id)
      open(hashButton || activeOpenButton)
    }
  })
}

export { mountPageDrawers }
